export const publicationConstant = [
  {
    "id":"pub_001",
    "title": "Diverse reactivity patterns of nickel deposited on gold and tungsten surfaces",
    "authors":[
      " G. U. Kulkarni",
      "C. P. Vinod"
    ],
    "other_details":"Appl. Surf. Sci., 115, 336 (1997).",
    year:"1997"
  },{
    "id":"pub_002",
    "title":"Size dependent changes on the electronic structure of metal clusters as investigated by Scanning tunneling spectroscopy",
    authors: [
      "C. P. Vinod",
      "G. U. Kulkarni",
      "C. N. R. Rao"
    ],
    other_details:"Chem.Phys. Lett., 289, 329 (1998).",
    year:"1998"
  },
  {
    id:"pub_003",
    title:"Facile CO bond scission in alcohols on Zn surfaces",
    authors: [
      "K. R. Hari Kumar",
      "C. P. Vinod",
      "G. U. Kulkarni",
      "C. N. R. Rao"
    ],
    other_details:"J. Phys. Chem.B., 103, 2445 (1999).",
    year:'1999'
  },
  {
    id: "pub_004",
    title:"Formation of aligned carbon and carbon-nitrogen nanotubes on silica-supported iron and cobalt catalysts",
    authors:[
      "Manashi Nath",
      "B. C. Satish Kumar",
      "A. Govindraj",
      "C. P. Vinod",
      "C. N. R. Rao"
    ],
    other_details:"Chem. Phys. Lett., 322, 333 (2000).",
    year:"2000"
  },{
    id:"pub_005",
    title:"Interaction of carbon monoxide with Cu-Pd and Cu-Ni bimetallic clusters",
    authors: [
      "C. P. Vinod",
      "K. R. Hari Kumar",
      "G. U. Kulkarni",
      "C. N. R. Rao"
    ],
    other_details:"Topics in Catalysis., 11/12, 293 (2000).",
    year:"2000"
  },{
    id:"pub_006",
    title:"A method employing STM for the estimation of relative changes in the work function of modified metal tips",
    authors: [
      "R. B. Sharma",
      "C. P. Vinod",
      "G. U. Kulkarni"
    ],
    other_details:" Bulletin of Material Science., 25, 247 (2002).",
    year:"2002"
  },{
    id:"pub_007",
    title:"Boron nitride nanotubes and nanowires",
    authors: [
      "F. L. Deepak",
      "C. P. Vinod",
      "K. Mukhopadhyay",
      "A. Govindaraj",
      "C. N. R. Rao"
    ],
    other_details:"Chem. Phys. Lett., 353, 345 (2002).",
    year:"2002"
  },{
    id: "pub_008",
    title:"Nanoscale catalysis by Gold, Surface Chemistry and Catalysis",
    authors:[
      "G. U. Kulkarni",
      "C. P. Vinod",
      "C. N. R. Rao"
    ],
    other_details:"(Eds. A. Carley, P. Davies, G. Hutchings and M. Spencer, Springer, 2002)., , 191 - 206 (2002).",
    year:"2002"
  },{
    id:"pub_009",
    title:"A methanol-water complex stabilized on a Zn(0001) surface",
    authors:[
      "S. Vijayalakhshmi",
      "C. P. Vinod",
      "G. U. Kulkarni"
    ],
    other_details:"Surf. Rev. Lett., 10, 87 (2003).",
    year:"2003"
  },{
    id:"pub_010",
    title:"Polyethersulfone supported titanium complexes as ethylene polymerization catalysts",
    authors:[
      "V. Gupta",
      "C. P. Vinod",
      "G. U. Kulkarni",
      "G. K. Lahiri",
      "N. Maity",
      "S. Bhaduri"
    ],
    other_details:" Current Science., 88 ( 7), 1162 (2005).",
    year:"2005"
  },{
    id:"pub_011",
    title:"Synthesis and Reactivity of Dimethyl Gold Complexes Supported on MgO: Characterization by Infrared and X-ray Absorption Spectroscopies",
    authors:[
      "Javier Guzman",
      "Bruce G. Anderson",
      "C. P. Vinod",
      "Kanaparthi Ramesh",
      "J. W. Niemantsverdriet",
      "Bruce C. Gates"
    ],
    other_details:"Langmuir., 21(8), 3675 (2005).",
    year:'2005'
  },{
    id:"pub_012",
    title:"Interaction of small molecules with Au(310): Decomposition of NO",
    authors: [
      "C.P.Vinod",
      "J.W. Niemantsverdriet",
      "B. E. Nieuwenhuys"
    ],
    other_details:"Applied Catalysis A-General., 291 (1-2), 93 (2005).",
    year:"2005"
  },{
    id:"pub_013",
    title:"NH3 adsorption and decomposition on Ir(110), a combined TPD and high resolution “fast” XPS study",
    authors:[
      "C.J. Westrate",
      "E. D. L. Rienks",
      "J. W. Bakker",
      "S. Lizzit",
      "L. Petaccia",
      "A. Baraldi",
      "C. P. Vinod",
      "B. E. Nieuwenhuys"
    ],
    other_details:"J. Chem. Phys., 122, 184705 (2005).",
    year:'2005'
  },{
    id:"pub_014",
    title:"Zeolite NaY-supported gold complexes prepared from Au(CH3)2(C5H7O2): reactivity with carbon monoxide",
    authors:[
      "Juan C. Fierro-Gonzalez",
      "Bruce G. Anderson",
      "Kanaparthi Ramesh",
      "C. P. Vinod",
      "J. W. Niemantsverdriet",
      "Bruce C. Gates"
    ],
    other_details:"Cat. Lett., 101 (3–4), 265 (2005).",
    year:'2005'
  },{
    id:"pub_015",
    title:"The role of Oad in the decomposition of NH3 adsorbed on Ir(110): a combined TPD and high-energy resolution fast XPS study",
    authors:[
      "C. J. Weststrate",
      "J. W. Bakker",
      "E. D. L. Rienks",
      "C. P. Vinod",
      "S. Lizzit",
      "L. Petaccia",
      "A. Baraldi",
      "B. E. Nieuwenhuys"
    ],
    other_details:"Phys. Chem. Chem. Phys., 7(13), 2629 (2005).",
    year:'2005'
  },{
    id:"pub_016",
    title:"Chaos, oscillations and the golden future of catalysis",
    authors:[
      "B.E. Nieuwenhuys",
      "A.C. Gluhoi",
      "E.D.L. Rienks",
      "C.J. Weststrate",
      "C.P. Vinod"
    ],
    other_details:"Catalysis Today., 100 (1-2), 49 (2005).",
    year:'2005'
  },{
    id:"pub_017",
    title:"Selective NH3 oxidation on (110) and (111) iridium surfaces",
    authors:[
      "Weststrate CJ",
      "Bakker JW",
      "Rienks EDL",
      "Martinez JR",
      "Vinod C.P.",
      "Lizzit S",
      'Petaccia L',
      "Baraldi A",
      "Nieuwenhuys BE"
    ],
    other_details:" Journal of Catalysis., 235 (1), 92 (2005).",
    year:'2005'
  },{
    id:"pub_018",
    title:"Decomposition of methanol on Au(310)",
    authors:[
      "C.P.Vinod*",
      "J.W. Niemantsverdriet",
      "B. E. Nieuwenhuys*"
    ],
    other_details:"Phys. Chem. Chem. Phys., 7(8), 1824 (2005).",
    year:'2005'
  },{
    id:"pub_019",
    title:"Tricarbonyls of low-coordinated Au(0) atoms in zeolite-supported gold nanoparticles: Evidence from infrared and X-ray absorption spectroscopies",
    authors:[
      "Anderson BG",
      "Fierro-Gonzalez JC",
      "Ramesh K",
      "Vinod C.P.",
      "Niemantsverdriet JW",
      "Gates BC"
    ],
    other_details:"Langmuir., 22 (9), 4310 (2006).",
    year:"2006"
  },{
    id:"pub_020",
    title:"Synchrotron XPS and desorption study of the NO chemistry on a stepped Pt surface",
    authors:[
      "Weststrate CJ",
      "Bakker JW",
      "Rienks EDL",
      "Vinod C.P.",
      "Lizzit S",
      "Petaccia L",
      "Baraldi A",
      "Nieuwenhuys BE"
    ],
    other_details:"Surface Science., 600 (10), 1991 (2006).",
    year:'2006'
  },{
    id:"pub_021",
    title:"Ammonia oxidation on Pt(410)",
    authors:[
      "C.J. Weststrate",
      "J.W. Bakker",
      "E.D.L. Rienks",
      "C.P. Vinod",
      "A.V. Matveev",
      "V.V. Gorodetskii",
      "B.E. Nieuwenhuys"
    ],
    other_details:"Journal of Catalysis., 242, 184 (2006).",
    year:'2006'
  },{
    id:"pub_022",
    title:"Reactivity of crotonaldehyde and propene over Au/Pd(111) surfaces",
    authors:[
      "James Naughton",
      "Adam F. Lee",
      "Sarah Thompson",
      "Vinod C. P.",
      "Karen Wilson"
    ],
    other_details:"Phys. Chem. Chem. Phys., 12, 2670 (2010).",
    year:"2010"
  },{
    id:"pub_023",
    title:"Surface science as a tool for probing nanocatalysis phenomena",
    authors:[
      "C. P. Vinod"
    ],
    other_details:"Catalysis Today., 154, 113 (2010).",
    year:'2010'
  },{
    id:"pub_024",
    title:"Surface X-ray studies of catalytic clean technologies",
    authors:[
      "Adam F Lee",
      "Vinod. C. P.",
      "Karen Wilson"
    ],
    other_details:"Chemical Communications., 46, 3827 (2010).",
    year:"2010"
  },{
    id:"pub_025",
    title:"Recent advances in the heterogeneously catalysed aerobic selective oxidation of alcohols",
    authors:[
      "C. P. Vinod",
      "Karen Wilson",
      "Adam F. Lee"
    ],
    other_details:"J Chem Technol Biotechnology., 86(2), 161 (2011).",
    year:"2011"
  },{
    id:"pub_026",
    title:"A simple one pot synthesis of nano gold–mesoporous silica and its oxidation catalysis",
    authors:[
      "A. C. Sunil Sekhar",
      "Kumarsrinivasan Sivaranjani",
      "Chinnakonda S. Gopinath*",
      "C.P. Vinod*"
    ],
    other_details:"Catalysis Today., 198, 92 (2012).",
    year:"2012"
  },{
    id:"pub_027",
    title:"Synthesis and catalytic activity of monodisperse gold–mesoporous silica core–shell nanocatalysts",
    authors: [
      "A. C. Sunil Sekhar",
      "C. J. Meera",
      "K. V. Ziyad",
      "Chinnakonda. S. Gopinath",
      "C. P. Vinod*"
    ],
    other_details:"Catal. Sci. Technol., 3, 1190 (2013).",
    year:"2013"
  },{
    id:"pub_028",
    title:"Insights into heterogeneous catalysis through surface science techniques",
    authors: [
      "C. P. Vinod"
    ],
    other_details:"NEW AND FUTURE DEVELOPMENTS IN CATALYSIS: CATALYSIS BY NANOPARTICLES (Elsevier)., Chapter 12, 289 - 304 (2013)",
    year:"2013",
    doi:"https://10.1016/B978-0-444-53874-1.00012-3."
  },{
    id:"pub_029",
    title:"Design and Performance Aspects of a Custom-Built Ambient Pressure Photoelectron Spectrometer toward Bridging the Pressure Gap: Oxidation of Cu, Ag, and Au Surfaces at 1 mbar O-2 Pressure",
    authors:[
      "Roy",
      "Kanak",
      "Vinod, C. P*",
      "Gopinath Chinnakonda S*"
    ],
    other_details:" J. Phys. Chem C., 117, 4717 (2013).",
    year:"2013"
  },{
    id:"pub_030",
    title:"Synthesis and Reactivity of Magnetically Diverse Au@Ni Core-shell Nanostructures",
    authors:[
      "Vysakh A. Bharathan",
      "Govind K Raj",
      "P. A. Joy",
      "C. P. Vinod*"
    ],
    other_details:"Particle & Particle Systems Characterization., 31, 236 - 244 (2014)",
    year:"2014",
    doi:"https://10.1002/ppsc.201300195."
  },{
    id:"pub_031",
    title:"Structure Sensitive Chemical Reactivity by Palladium Concave Nanocubes and Nanoflowers Synthesised by Seed Mediated Procedure in Aqueous Medium",
    authors:[
      "S. Sreedhala",
      "V. SudheeshKumar",
      "C. P. Vinod*"
    ],
    other_details:"Nanoscale., 6, 7496 - 7502 (2014)",
    year:'2014',
    doi:"https://10.1039/c4nr01283f."
  },{
    id:"pub_032",
    title:"Oxidation catalysis by large trisoctahedral gold nanoparticles: Mind the step!",
    authors:[
      "S. Sreedhala",
      "V. Sudheeshkumar",
      "C. P. Vinod*"
    ],
    other_details:"Catalysis Today., 244, 177 - 183 (2015)",
    year:"2015",
    doi:"https://10.1016/j.cattod.2014.02.049."
  },{
    id:"pub_033",
    title:"Activity enhancement on Titanium incorporation: Au@Ti-SiO2 core shell nanocatalysts for CO oxidation reaction",
    authors:[
      "A. C. Sunil Sekhar",
      "K. V. Ziyad",
      "Y. Soni",
      "C. P. Vinod*"
    ],
    other_details:"ChemCatChem., 7 (7), 1222 - 1230 (2015)",
    year:"2015",
    doi:"https://10.1002/cctc.201402954."
  },{
    id:"pub_034",
    title:"Demonstration of Synergistic Catalysis in Au@Ni Bimetallic Core Shell Nanostructures",
    authors:[
      "Vysakh A. Bharathan",
      "Chinchu Lizen Babu",
      "C. P. Vinod*"
    ],
    other_details:"J Phys Chem C., 119 (15), 8138 - 8146 (2015)",
    year:"2015",
    doi:"https://10.1021/jp5128089."
  },{
    id:"pub_035",
    title:"Mesoporous TUD-1 supported indium oxide nanoparticles for epoxidation of styrene using molecular O2",
    authors:[
      "Sumbul Rahman",
      "S. A. Farooqui",
      "Aditya Rai",
      "Rawesh Kumar",
      "Chiranjit Santra",
      "Vinod C P",
      "Gopala Ram Bhadu",
      "Debasis Sen",
      "S. Mazumder",
      "Sudip Maity",
      "Anil Sinha",
      "Biswajit Chowdhury"
    ],
    other_details:"RSC Advances., (Just Accepted), (2015)",
    year:"2015",
    doi:"https://10.1039/C5RA03400K."
  },{
    id:"pub_036",
    title:"Pd loaded amphiphilic COF as catalyst for multi-fold Heck reactions, C-C couplings and CO oxidation",
    authors:[
      "D. Mullangi",
      "S. Nandi",
      "S. Shalini",
      "S. Sreedhala",
      "C. P. Vinod",
      "R. Vaidhyanathan"
    ],
    other_details:"Nature Scientific Reports., , (2015)",
    year:'2015',
    doi:"https://10.1038/srep10876."
  },{
    id:"pub_037",
    title:"Surfactant assisted formation of Ruthenium nanochains under mild conditions and their catalytic CO oxidation activity",
    authors: [
      "S. Sreedhala",
      "C. P. Vinod*"
    ],
    other_details:"Chemical Communications., 51, 10178 - 10181 (2015)",
    year:'2015',
    doi:"https://10.1039/C4CC09430A."
  },{
    id:"pub_038",
    title:"Preparation of mesoporous titanosilicate with isolated Ti active centers for cyclohexene oxidation",
    authors:[
      "S. Gupta",
      "C. P. Vinod",
      "D. Jagadeeshan"
    ],
    other_details:"RSC Advances., 5, 92371 - 92377 (2015)",
    year:"2015",
    doi:"https://10.1039/c5ra18044a."
  },{
    id:"pub_039",
    title:"Porous Thin Films Towards Bridging the Material Gap in Heterogeneous Catalysis",
    authors:[
      "Anjani Dubey",
      "Sadhu K. Kolekar",
      "Edwin S. Gnanakumar",
      "Kanak Roy",
      "C. P. Vinod",
      "Chinnakonda S. Gopinatha"
    ],
    other_details:"Catalysis, Structure and Reactivity., (accepted), (2016).",
    year:"2016"
  },{
    id:"pub_040",
    title:"A simple, phosphine free, reusable Pd(II)-2,2’-Dihydroxybenzophenone-SBA-15 catalyst for arylation and hydrogenation reactions of alkenes",
    authors:[
      "Anish Lazar",
      "C P Vinod",
      "A. P. Singh*"
    ],
    other_details:"New Journal of Chemistry., (accepted), (2016)",
    year:"2016",
    doi:"https://10.1039/C5NJ02686E."
  },{
    id:"pub_041",
    title:"Correlating the role of hydrophilic/hydrophobic nature of Rh(I) and Ru(II) supported organosilica/silica catalysts in organotransformation reactions",
    authors:[
      "Anish Lazar",
      "Shoy George",
      "Jithesh P R",
      "C P Vinod",
      "A. P. Singh*"
    ],
    other_details:"Applied Catalysis A., 513, 138 - 146 (2016)",
    year:'2016',
    doi:"https://10.1016/j.apcata.2015.12.026."
  },{
    id:"pub_042",
    title:"Synthesis of Au@Ni bimetallic core shell nanoparticle and nanochains in soyabean oil and their catalytic hydrogenation reactions",
    authors:[
      "A. B. Vysakh",
      "V. Yadukiran",
      "Anish Lazar",
      "A. P. Singh",
      " C. P. Vinod*"
    ],
    other_details:"Chemistry Select., 1 (2), 140 - 146 (2016)",
    year:"2016",
    doi:"https://10.1002/slct.201500006."
  },{
    id:"pub_043",
    title:"Phenyl acetylene hydrogenation on Au@Ni bimetallic core shell nanoparticles synthesized under mild conditions",
    authors:[
      "A. B. Vysakh",
      "Anish Lazar",
      "V. Yadukiran",
      "A. P. Singh",
      "C. P. Vinod*"
    ],
    other_details:"Catalysis Science and Technology., 6, 708 - 712 (2016)",
    year:"2016",
    doi:"https://10.1039/C5CY02005K."
  },{
    id:"pub_044",
    title:"CO oxidation on large high index faceted Pd nanostructures",
    authors:[
      "S. Sreedhala",
      "V. Sudheeshkumar",
      "C. P. Vinod*"
    ],
    other_details:"Journal of Catalysis., 337, 138 - 144 (2016)",
    year:"2016",
    doi:"https://10.1016/j.jcat.2016.01.017."
  },{
    id:"pub_045",
    title:"Gold incorporated mesoporous silica thin film model surface as a robust SERS and catalytically active substrate",
    authors:[
      "A C Sunil Sekhar*",
      "C P Vinod *"
    ],
    other_details:`Molecules., (invited article for a speciail issue "Coinage Metal (Copper, Silver, and Gold) Catalysis", (2016).`,
    year:"2016"
  },{
    id:"pub_046",
    title:" Large Trisoctahedral Au nanoparticles encapsulated inside porous silica catalyses CO oxidation at room temperature: Probing the effect of encapsulation and the role of step atoms and interfaces",
    authors:[
      "Sreedhala S",
      "Shruti Maheshwari",
      "Betsy K J",
      "C. P. Vinod*"
    ],
    other_details:"Applied Catalysis A: General., 524, 1 - 7 (2016)",
    year:"2016",
    doi:"https://10.1016/j.apcata.2016.05.023."
  },
  {
    id:"pub_047",
    title:"Highly stable In-SBA-15 catalyst for vapor phase Beckmann rearrangement reaction",
    authors:[
      "Rawesh Kumara",
      "Sneha Shaha",
      "Jitendra Bahadur",
      "Yuri B. Melnichenko",
      "Debasis Sen",
      "S. Mazumder",
      "C. P. Vinod",
      "Biswajit Chowdhury"
    ],
    other_details:"Microporous and Mesoporous Materials., (2016)",
    year:"2016",
    doi:"https://10.1016/j.micromeso.2016.07.024."
  },{
    id:"pub_048",
    title:"Low Band Gap Benzimidazole COF Supported Ni3N as highly active OER catalyst",
    authors:[
      "Shyamapada Nandi",
      "Santosh Kumar Singh",
      "Dinesh Mullangi",
      "Rajith Illathvalappil",
      "Leena George",
      "C. P. Vinod",
      "Sreekumar Kurungot",
      "Ramanathan Vaidhyanathan"
    ],
    other_details:"Advanced Energy Materials., 6(24), (2016)",
    year:"2016",
    doi:"https://10.1002/aenm.201601189."
  },{
    id:"pub_049",
    title:"A heterogeneous route for transfer hydrogenation reactions of ketones using Ru (II) Cymene complex over modified benzene-organosilica (PMO B)",
    authors:[
      "A Lazar",
      "S Silpa",
      "C.P. Vinod",
      "AP Singh"
    ],
    other_details:"Molecular Catalysis., 440, 66 - 74 (2017)",
    year:"2017",
    doi:"https://https://doi.org/10.1016/j.mcat.2017.07.018."
  },{
    id:"pub_050",
    title:"Exploration of amination reactions on highly extendable active sites of Pd (II)-3-allylsalicylaldiminophenol (ASIP) complex over thiofunctionalized SBA-15",
    authors:[
      "A Lazar",
      "C.P. Vinod",
      "AP Singh"
    ],
    other_details:" Microporous and Mesoporous Materials., 242, 173 - 181 (2017)",
    year:"2017",
    doi:"https://https://doi.org/10.1016/j.micromeso.2017.01.026."
  },{
    id:"pub_051",
    title:"A Convenient Route for Au@Ti-SiO2 Nanocatalyst Synthesis and its Application for Room Temperature CO Oxidation",
    authors:[
      "Yogita Soni",
      "E. A. Anumol",
      "Chandrani Nayak",
      "Leonard Deepak Francis",
      "C. P. Vinod"
    ],
    other_details:"The Journal of Physical Chemistry C., 121(9), 4946 - 4957 (2017)",
    year:"2017",
    doi:"https://10.1021/acs.jpcc.6b10202."
  },{
    id:"pub_052",
    title:"Diverse reactivity trends of Ni surface in Au@Ni core-shell nanoparticle probed by Near Ambient Pressure (NAP) XPS",
    authors:[
      "A B Vysakh",
      "Ruchi Jain",
      "C S Gopinath",
      "C. P. Vinod*"
    ],
    other_details:"Catalysis Science & Technology., (2017)",
    year:"2017",
    doi:"https://10.1039/C7CY01070B."
  },{
    id:"pub_053",
    title:`Model Nanoparticles in Catalysis, book chapter in "Metal Nanoparticles and Clusters Advances in Synthesis, Properties and Applications"`,
    authors:[
      "C P Vinod*",
      "A B Vysakh",
      "S Sreedhala"
    ],
    other_details:"Springer (2017)., , 165 - 199 (2018)",
    year:"2017",
    doi:"https://doi.org/10.1007/978-3-319-68053-8_5."
  },{
    id:"pub_054",
    title:" Ru(II)-functionalized SBA-15 as highly chemoselective, acid free and sustainable heterogeneous catalyst for acetalization of aldehydes and ketones",
    authors:[
      "Anish Lazar",
      "K J Betsy",
      "C. P. Vinod",
      "A. P. Singh"
    ],
    other_details:"Catalysis Communications., 104, 62 - 66 (2018)",
    year:"2018",
    doi:"https://doi.org/10.1016/j.catcom.2017.10.016."
  },{
    id:"pub_055",
    title:"Highly selective aqueous phase hydrogenation of phenols over nanostructured RuO 2 on MCM-41 catalysts",
    authors:[
      "K. J. Betsy",
      "Anish Lazar",
      "C. P. Vinod*"
    ],
    other_details:"Nano-Structures & Nano-Objects., 13, 36 - 43 (2018)",
    year:"2018",
    doi:"https://doi.org/10.1016/j.nanoso.2017.11.004"
  },{
    id:"pub_056",
    title:"Iron Catalyzed Hydroformylation of Alkenes under Mild Conditions: Evidence of an Fe (II) Catalyzed Process",
    authors:[
      "Swechchha Pandey",
      "K Vipin Raj",
      "Dinesh R Shinde",
      "Kumar Vanka",
      "Varchaswal Kashyap",
      "Sreekumar Kurungot",
      "C P Vinod",
      "Samir H Chikkali*"
    ],
    other_details:"Journal of the American Chemical Society., , (2018)",
    year:"2018",
    doi:"https://10.1021/jacs.8b01286."
  },{
    id:"pub_057",
    title:"Selective oxidation of cyclohexane to cyclohexanone using chromium oxide supported mesoporous MCM-41 nanospheres: Probing the nature of catalytically active chromium sites",
    authors:[
      "K. J. Betsy",
      "Chandrani Nayak",
      "Anish Lazar",
      "Athira Krishnan",
      "D. Bhattacharyya",
      "S. N. Jha",
      "C. P. Vinod*"
    ],
    other_details:"ChemCatChem (2018)",
    year:"2018",
    doi:"10.1002/cctc.201800309"
  },{
    id:"pub_058",
    title:"Judicious Reduction of Supported Ti Catalyst Enables Access to Disentangled Ultrahigh Molecular Weight Polyethylene",
    authors:[
      "Ravindra P Gote",
      "Dipa Mandal",
      "Ketan Patel",
      "Krishnaroop Chaudhuri",
      "C.P. Vinod",
      "Ashish K Lele",
      "Samir H Chikkali*"
    ],
    other_details:"Macromolecules., , (2018)",
    year:"2018",
    doi:"https://10.1002/cnma.201800081."
  },{
    id:"pub_059",
    title:"Mesoporous shell@macroporous core aluminosilicates as sustainable nanocatalysts for direct N-alkylation of Amines",
    authors:[
      "A C Sunil Sekhar",
      "Anumol Erumpukuthickal Ashokkumar",
      "C T Cygnet",
      "S Vidhya Lakshmi",
      "Francis Leonard Deepak",
      "C P Vinod*"
    ],
    other_details:"ChemNanoMat., (accepted as VIP article), (2018)",
    year:"2018",
    doi:"https://10.1002/cnma.201800081."
  },{
    id:"pub_060",
    title:"Enhanced selectivity of 3-D ordered macroporous Pt/Al2O3 catalysts in nitrites removal from water",
    authors:[
      "A.C. SunilSekhar",
      "A.Zaki",
      "S.Troncea",
      "S.Casale",
      "C.P.Vinod",
      "J.P.Dacquin*",
      "P.Granger"
    ],
    other_details:"Applied Catalysis A: General., , (2018)",
    year:"2018",
    doi:"https://10.1016/j.apcata.2018.07.014."
  },{
    id:"pub_061",
    title:"Highly Stable COF?Supported Co/Co(OH)2 Nanoparticles Heterogeneous Catalyst for Reduction of Nitrile/Nitro Compounds under Mild Conditions",
    authors:[
      "Dinesh Mullangi",
      "Debanjan Chakraborty",
      "Anu Pradeep",
      "Vijay Koshti",
      "C. P. Vinod",
      "Soumendranath Panja",
      "Sunil Nair",
      "Ramanathan Vaidhyanathan*"
    ],
    other_details:"Small., , (2018)",
    year:"2018",
    doi:"https://10.1002/smll.201801233."
  },{
    id:"pub_062",
    title:"Distribution of Water in Pores of Periodic Mesoporous OrganoSilicates – a Proton Solid State MAS NMR Study",
    authors:[
      "V. S. Veena",
      "Illath Kavya",
      "Lazar Anish",
      "C. P. Vinod",
      "T. G. Ajithkumar",
      "Sundaresan Jayanthi"
    ],
    other_details:"Physical Chemistry Chemical Physics (PCCP). (2018)",
    year:"2018",
    doi:"https://doi.org/10.1039/C8CP04902E"
  },{
    id:"pub_063",
    title:"Role of oxygen vacancies and interstitials on structural phase transition, grain growth, and optical properties of Ga doped TiO2",
    authors:[
      "N Khatun",
      "S Tiwari",
      "C.P. Vinod",
      "CM Tseng",
      "S Wei Liu",
      "S Biring",
      "S Sen"
    ],
    other_details:"Journal of Applied Physics., 123 (24), 245702 (2018)",
    year:"2018",
    doi:"https://doi.org/10.1063/1.5027672"
  },{
    id:"pub_064",
    title:"Nickel-Catalyzed Straightforward and Regioselective C-H Alkenylation of Indoles with Alkenyl Bromides: Scope and Mechanistic Aspect",
    authors:[
      "Rahul A Jagtap",
      "C. P. Vinod",
      "B. Punji*"
    ],
    other_details:"ACS Catalysis., 9 (1), 431 - 441 (2018)",
    year:"2018",
    doi:"https://doi.org/10.1021/acscatal.8b04267"
  },{
    id:"pub_065",
    title:"One Pot Ligand Exchange Method for a Highly Stable Au- SBA- 15 Catalyst and its room temperature CO Oxidation",
    authors:[
      "Yogita Soni",
      "Kavya Illath",
      "T. G. Ajithkumar",
      "C. P. Vinod*"
    ],
    other_details:"Chemical Communications., 54 (91), 12412 - 12415 (2018)",
    year:"2018",
    doi:"https://doi.org/10.1039/C8CC90494D"
  },{
    id:"pub_066",
    title:"A direct Z-scheme g-C3N4/FeWO4 nanocomposite for Enhanced and Selective Photocatalytic CO2 Reduction under Visible Light",
    authors:[
      "R Bhosale",
      "S Jain",
      "C.P. Vinod",
      "S Kumar",
      "S Ogale"
    ],
    other_details:"ACS applied materials & interfaces., 11 (6), 6174 - 6183 (2019).",
    year:"2018",
    doi:"https://doi.org/10.1021/acsami.8b22434"
  },{
    id:"pub_067",
    title:"Role of Li+ and Fe3+ in modified ZnO: Structural, vibrational, opto-electronic, mechanical and magnetic properties",
    authors:[
      "Gaurav Bajpai",
      "Igamcha Moirangthem",
      "Shuvam Sarkar",
      "Sudipta RoyBarman",
      "C.P.Vinod",
      "Shubhra Bajpai",
      "Sk. Riyajuddin",
      "Kaushik Ghosh",
      "Dharma R. Basaulah",
      "Mahmud Khan",
      "Shun-WeiLiui",
      "Sajal Biring",
      "SomadityaSen"
    ],
    other_details:"Ceramics International., 45, Issue 6, 7232 - 7243 (2019).",
    year:"2019",
    doi:"https://doi.org/10.1039/C8CP04902E" //not found
  },{
    id:"pub_068",
    title:"In-situ X ray Absorption Spectroscopy Study of Fischer Tropsch Reaction with Co catalysts",
    authors:[
      "Chandrani. Nayak",
      "Preeti Jain",
      "C. P. Vinod",
      "S. N. Jha",
      "D. Bhattacharyyaa"
    ],
    other_details:"Journal of Synchrotron Radiation., 26, 137 - 144 (2019).",
    year:"2019",
    doi:"https://doi.org/10.1107/S1600577518015588"
  },{
    id:"pub_069",
    title:"Palladium Impregnated Amine Co-condensed Hexagonal Mesoporous Silica: A Novel Catalyst in Tailoring Suzuki and Heck Coupling Reactions in Base Free Condition",
    authors:[
      "Prangya Paramita Das",
      "C. P. Vinod",
      "Samik Nanda",
      "Debasis Sen",
      "Biswajit Chowdhury"
    ],
    other_details:"Chemistry Select., (2019)",
    year:"2019",
    doi:"https://doi.org/10.1002/slct.201803485"
  },{
    id:"pub_070",
    title:"Au based Ni and Co Bimetallic Core Shell Nanocatalysts for room temperature selective Decomposition of Hydrous Hydrazine to hydrogen",
    authors:[
      "Preeti Jain",
      "K. A. Anila",
      "C. P. Vinod*"
    ],
    other_details:"Chemistry Select., 4 (9), 2734 - 2740 (2019).",
    year:"2019",
    doi:"https://doi.org/10.1039/C8CP04902E" //not found
  },{
    id:"pub_071",
    title:"Cu/Cu2O Nanoparticles Supported on a Phenol-Pyridyl COF as Heterogeneous Catalyst for the Synthesis of Unsymmetrical Diynes via Glaser-Hay Coupling",
    authors:[
      "D. Chakraborty",
      "S. Nandi",
      "D. Mullangi",
      "S. Haldar",
      "C. P. Vinod",
      "R. Vaidhyanathan"
    ],
    other_details:"ACS Applied Materials & Interfaces., (2019)",
    year:"2019",
    doi:"https://doi.org/10.1021/acsami.9b02860"
  },{
    id:"pub_072",
    title:"Carbon derived from soft pyrolysis of COF as a support for small-sized RuO2 showing exceptionally low-overpotential for OER",
    authors:[
      "Debanjan Chakraborty",
      "Shyamapada Nandi",
      "Rajith Illathvalappil",
      "Dinesh Mullangi",
      "Rahul Maity",
      "Santosh K. Singh",
      "Sattwick Haldar",
      "C. P. Vinod",
      "Sreekumar Kurungot",
      "Ramanathan Vaidhyanathan*"
    ],
    other_details:"ACS Omega., (2019)",
    year:"2019",
    doi:"https://doi.org/10.1021/acsomega.9b01777"
  },{
    id:"pub_073",
    title:"Aqueous-Phase Differentiation and Speciation of Fe3+ and Fe2+ Using Water-Stable Photoluminescent Lanthanide-Based Metal-Organic Framework",
    authors:[
      "Rahul Maity",
      "Debanjan Chakraborty",
      "Shyamapada Nandi",
      "Ankit Kumar Yadav",
      "Dinesh Mullangi",
      "C.P. Vinod",
      "Ramanathan Vaidhyanathan"
    ],
    other_details:"ACS Applied Nano Materials., (2019)",
    year:"2019",
    doi:"https://doi.org/10.1021/acsanm.9b01047"
  },{
    id:"pub_074",
    title:"MnO2@Fe3O4 MNP: An Efficient and Recyclable Heterogeneous Catalyst for Benzylic sp3 C?H Oxidation",
    authors:[
      "Boopathy Gnanaprakasam*",
      "Akanksha M Pandey",
      "Sandip G Agalave",
      "C. P. Vinod"
    ],
    other_details:"Chemistry An Asian Journal., (2019)",
    year:"2019",
    doi:"https://doi.org/10.1002/asia.201900810"
  },{
    id:"pub_075",
    title:"Surfactant free Synthesis of Au@Ni Core-shell Nanochains in Aqueous Medium as Efficient Transfer Hydrogenation Catalyst",
    authors:[
      "A B Vysakh",
      "K J Shebin",
      "Ruchi Jain",
      "P Sumanta",
      "Chinnakonda S Gopinath",
      "C P Vinod*"
    ],
    other_details:"Applied Catalysis A- General., 575, 93 - 100 (2019).",
    year:"2019",
    doi:"https://doi.org/10.1016/j.apcata.2019.01.017"
  },{
    id:"pub_076",
    title:"Nickel-catalyzed C-H alkylation of indoles with unactivated alkyl chlorides: Evidence of Ni(I)/Ni(III) pathway",
    authors:[
      "Dilip K. Pandey",
      "Shidheshwar B. Ankade",
      "Abad Ali",
      "C. P. Vinod",
      "Benudhar Punji*"
    ],
    other_details:"Chemical Science., (2019)",
    year:"2019",
    doi:"https://doi.org/10.1039/C9SC01446B"
  },{
    id:"pub_077",
    title:"Ag nanoparticles supported on a resorcinol?phenylenediamine based COF for chemical fixation of CO2",
    authors:[
      "Debanjan Chakraborty",
      "Pragalbh Shekhar",
      "Himan Dev Singh",
      "Rinku Kushwaha",
      "C P Vinod",
      "Ramanathan Vaidhyanathan"
    ],
    other_details:"Chemistry–An Asian Journal., (2019)",
    year:"2019",
    doi:"https://doi.org/10.1002/asia.201901157"
  },{
    id:"pub_078",
    title:"Mechanistic Insights into the Pathways of Phenol Hydrogenation on Pd Nanostructures",
    authors:[
      "Govind Porwal",
      "Shelaka Gupta",
      "Seshadri Sreedhala",
      "Joes Elizabeth",
      "Tuhin Khan",
      "M. Ali Haider*",
      "C. P. Vinod*"
    ],
    other_details:"ACS Sustainable Chemistry & Engineering., (2019)",
    year:"2019",
    doi:"https://doi.org/10.1021/acssuschemeng.9b03392"
  },{
    id:"pub_079",
    title:"Unprecedented Isomerism-Activity Relation in Molecular Electrocatalysis",
    authors:[
      "Alagar Raja Kottaichamy",
      "Shabbah Begum",
      "Neethu Christudas Dargily",
      "Mohammed Azeezulla Nazrulla",
      "Mruthyunjayachari Chattanahalli Devendrachari",
      "Zahid Manzoor Bhat",
      "Harish Makri Nimbegondi Kotresh*",
      "C. P. Vinod*",
      "Musthafa Ottakam Thotiyl*"
    ],
    other_details:"J. Phys. Chem. Lett., (2019)",
    year:"2019",
    doi:"https://doi.org/10.1021/acs.jpclett.9b02689"
  },{
    id:"pub_080",
    title:"Stress-Induced Electronic Structure Modulation of Manganese-Incorporated Ni2P Leading to Enhanced Activity for Water Splitting",
    authors:[
      "Shreya Sarkar",
      "Lakshay Dheer",
      "C. P. Vinod",
      "Ranjit Thapa",
      "Umesh V. Waghmare",
      "Sebastian C. Peter*"
    ],
    other_details:"ACS Appl. Energy Materials., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1021/acsaem.9b02097"
  },{
    id:"pub_081",
    title:"Geometrical Isomerism Directed Electrochemical Sensing",
    authors:[
      "Kottaichamy Alagar",
      "Begum Shabbah",
      "Devendrachari Mruthyunjayachari",
      "Manzoor Bhat Zahid",
      "Thimmappa Ravikumar",
      "Makri Nimbegondi Kotresh Harish*",
      "C. P. Vinod*",
      "Thotiyl Musthafa*"
    ],
    other_details:"Analytical Chemistry., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1021/acs.analchem.9b05753"
  },{
    id:"pub_082",
    title:"Dynamics in Amine-functionalized Mesoporous Hybrid Materials Probed through Deuterium MAS NMR and Molecular Dynamic Simulations",
    authors:[
      "V. S. Veena",
      "Illath Kavya",
      "Lazar Anish",
      "C. P. Vinod",
      "T. G. Ajithkumar",
      "Sundaresan Jayanthi*"
    ],
    other_details:"The Journal of Physical Chemistry C., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1021/acs.jpcc.9b11948"
  },{
    id:"pub_083",
    title:"Nanocrystalline Ag3PO4 for sunlight and ambient air driven oxidation of amines: high photocatalytic efficiency and a facile catalyst regeneration strategy",
    authors:[
      "Reeya Garg",
      "Sanjit Mondal",
      "LIPIPUSPA SAHOO",
      "C P Vinod",
      "Ujjal K. Gautam*"
    ],
    other_details:"ACS Applied Materials & Interfaces., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1021/acsami.0c05961"
  },{
    id:"pub_084",
    title:"Iron-Catalyzed C(sp2)-H Alkylation of Indolines and Benzo[h]quinoline with Unactivated Alkyl Chlorides through Chelation-Assistance",
    authors:[
      "Rahul A. Jagtap",
      "Pragnya Samal",
      "C. P. Vinod",
      "Sailaja Krishnamurty",
      "Benudhar Punji*"
    ],
    other_details:"ACS Catalysis., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1021/acscatal.0c02030"
  },{
    id:"pub_085",
    title:"Role of B site ion in bifunctional oxygen electrocatalysis: A structure property correlation study on doped Ca2Fe2O5 brownmillerites",
    authors:[
      "Shibin Thundiyil",
      "C P Vinod",
      "Sreekumar Kurungot",
      "R. Nandini Devi*"
    ],
    other_details:"PhysChemChemPhys., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1039/D0CP02391D"
  },{
    id:"pub_086",
    title:"Tweaking Palladium Electronic Structure to Attain Oxygen Reduction Activity Superior to Platinum/C",
    authors:[
      "Saurav Sarma",
      "Sai Manoj Kaja",
      "Vidyanshu Mishra",
      "C. P. Vinod",
      "Sebastian Peter*"
    ],
    other_details:"ACS Applied Energy Materials., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1021/acsaem.0c01241"
  },{
    id:"pub_087",
    title:"Nanoporous Covalent Organic Framework Embedded with Fe/Fe3O4 Nanoparticles as Air-Stable Low-Density Nanomagnets",
    authors:[
      "Rinku Kushwaha",
      "Dhananjayan Kaleeswaran",
      "Sattwick Haldar",
      "Debanjan Chakraborty",
      "Dinesh Mullangi",
      "Aditya Borah",
      "C. P. Vinod",
      "Ramaswamy Murugavel",
      "Ramanathan Vaidhyanathan*"
    ],
    other_details:"ACS Appl. Nano Mater., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1021/acsomega.9b01777"
  },{
    id:"pub_088",
    title:"Wavelength dependent luminescence decay kinetics in quantum confined g-C3N4 nanosheets exhibiting high photocatalytic efficiency upon plasmonic coupling",
    authors:[
      "Sanjit Mondal",
      "Lipipuspa Sahoo",
      "Yuvraj Vaishnav",
      "Samita Mishra",
      "Raj Sekhar Roy",
      "C. P. Vinod",
      "Arijit K De",
      "Ujjal K. Gautam*"
    ],
    other_details:" Journal of Materials Chemistry A., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1039/D0TA08001B"
  },{
    id:"pub_089",
    title:"Boron Nitride and Oxide Supported on Dendritic Fibrous Nanosilica for Catalytic Oxidative Dehydrogenation of Propane",
    authors:[
      "Rajesh Belgamwar",
      "Andrew GM Rankin",
      "Ayan Maity",
      "Amit Kumar Mishra",
      "Jennifer S Go?mez",
      "Julien Tre?bosc",
      "C P Vinod",
      "Olivier Lafon*",
      "Vivek Polshettiwar*"
    ],
    other_details:"ACS Sustainable Chemistry & Engineering., (2020)",
    year:"2020",
    doi:"https://doi.org/10.48550/arXiv.2011.00831"
  },{
    id:"pub_090",
    title:"Role of exposed crystal facets in the atmospheric pressure CO hydrogenation on Co3O4 nanostructures",
    authors:[
      "Preeti Jain",
      "Sharad Gupta",
      "C. P. Vinod*"
    ],
    other_details:"Nanostructures and Nanoobjects., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1016/j.nanoso.2020.100504"
  },{
    id:"pub_091",
    title:"Can We Identify the Salt–Cocrystal Continuum State Using XPS?",
    authors:[
      "Srinu Tothadi",
      "Tabrez Rafique Shaikh",
      "Sharad Gupta",
      "Rambabu Dandela",
      "C. P. Vinod",
      "Ashwini K. Nangia*"
    ],
    other_details:"Cryst. Growth Des., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1021/mp0601345"
  },{
    id:"pub_092",
    title:"Engineering pore morphology using silica template route over mesoporous cobalt oxide and its implications in atmospheric pressure carbon dioxide hydrogenation to olefins",
    authors:[
      "Sharad Gupta",
      "Carmen Ciotonea",
      "Sébastien Royer",
      "Jean-Philippe Dacquin*",
      "C. P. Vinod*"
    ],
    other_details:"Applied Materials Today., 19, 100586 (2020)",
    year:"2020",
    doi:"https://doi.org/10.1016/j.apmt.2020.100586"
  },{
    id:"pub_093",
    title:"CO2 Hydrogenation to Formate by Palladium Nanoparticles Supported on N-Incorporated Periodic Mesoporous Organosilica",
    authors:[
      "K. J. Betsy",
      "Anish Lazar",
      "Anjuna Pavithran",
      "C. P. Vinod*"
    ],
    other_details:"ACS Sustainable Chemistry & Engineering., (2020)",
    year:"2020",
    doi:"https://doi.org/10.1021/acssuschemeng.0c03860"
  },{
    id:"pub_094",
    title:"Spectroscopic Evidences for the Size Dependent Generation of Pd Species Responsible for the Low Temperature CO Oxidation Activity on Pd-SBA-15 Nanocatalyst",
    authors:[
      "Yogita Soni",
      "Sumanta Pradhan",
      "Mahesh K Bamnia",
      "AK Yadav",
      "SN Jha",
      "D Bhattacharyya",
      "Tuhin Suvra Khan",
      "MA Haider",
      "C.P. Vinod*"
    ],
    other_details:"Applied Catalysis B: Environmental., 272, 118934 (2020)",
    year:"2020",
    doi:"https://doi.org/10.1016/j.apcatb.2020.118934"
  },{
    id:"pub_095",
    title:"Unveiling the Roles of Lattice Strain and Descriptor Species on Pt-like Oxygen Reduction Activity in Pd-Bi catalysts",
    authors:[
      "Shreya Sarkar",
      "S. D. Ramarao",
      "Tisita Das",
      "Risov Das",
      "C. P. Vinod",
      "Sudip Chakraborty",
      "Sebastian C. Peter*"
    ],
    other_details:"ACS Catalysis., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1021/acscatal.0c03415"
  },{
    id:"pub_096",
    title:"Operando Generated Ordered Heterogeneous Catalyst for the Selective Conversion of CO2 to Methanol",
    authors:[
      "Arjun Cherevotan",
      "Jithu Raj",
      "Lakshay Dheer",
      "Soumyabrata Roy",
      "Shreya Sarkar",
      "Risov Das",
      "C P Vinod",
      "Shaojun Xu",
      "Peter P Wells",
      "Umesh Waghmare",
      "Sebastian Peter*"
    ],
    other_details:"ACS Energy Letters., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1021/acsenergylett.0c02614"
  },{
    id:"pub_097",
    title:"Conductive Interface Promoted Bifunctional Oxygen Reduction/Evolution Activity in Ultra-low Precious Metal based Hybrid Catalyst",
    authors:[
      "Shreya Sarkar",
      "Merin Varghese",
      "C. P. Vinod",
      "Sebastian C. Peter*"
    ],
    other_details:"Chemical Communications., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1039/D0CC08225B"
  },{
    id:"pub_098",
    title:"Facile transfer of excited electrons in Au/SnS2 nanosheets for efficient solar-driven selective organic transformations",
    authors:[
      "Sanjit Mondal",
      "Lipipuspa Sahoo",
      "C. P. Vinod",
      "Ujjal K. Gautam*"
    ],
    other_details:"Applied Catalysis B (Environmental)., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1016/j.apcatb.2021.119927"
  },{
    id:"pub_099",
    title:"Exceptional Capacitance Enhancement of a Non-conducting COF Through Potentialdriven Chemical Modulation by Redox Electrolyte",
    authors:[
      "Rinku Kushwaha",
      "Sattwick Haldar",
      "Pragalbh Shekhar",
      "Akshara Krishnan",
      "Jayeeta Saha",
      "Pramiti Hui",
      "C.P. Vinod",
      "Chandramouli Subramaniam",
      "Ramanathan Vaidhyanathan*"
    ],
    other_details:"Advanced Energy Materials., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1002/aenm.202003626"
  },{
    id:"pub_100",
    title:"Lithium Silicates Nanosheets with Excellent Capture Capacity and Kinetics with Unprecedented Stability for High-Temperature CO2 Capture",
    authors:[
      "Rajesh Belgamwar",
      "Ayan Maity",
      "Tisita Das",
      "Sudip Chakraborty",
      "C. P. Vinod",
      "Vivek Polshettiwar*"
    ],
    other_details:"Chemical Science., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1039/D0SC06843H"
  },{
    id:"pub_101",
    title:"'Autophagy’ and unique aerial oxygen harvesting properties exhibited by highly photocatalytic carbon quantum dots",
    authors:[
      "Sanjit Mondal",
      "C. P. Vinod",
      "Ujjal K. Gautam*"
    ],
    other_details:"Carbon., 181, 16 - 27 (2021)",
    year:"2021",
    doi:"https://doi.org/10.1016/j.carbon.2021.04.054"
  },{
    id:"pub_102",
    title:"Structure Tailored Non-Noble Metal based Ternary Chalcogenide Nanocrystals for Pt-like Electrocatalytic Hydrogen Production",
    authors:[
      "Shreya Sarkar",
      "Abhishek Rawat",
      "Tisita Das",
      "Mattia Gaboardi",
      "Sudip Chakraborty",
      "C. P. Vinod",
      "Sebastian C. Peter*"
    ],
    other_details:"ChemSusChem., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1002/cssc.202100967"
  },{
    id:"pub_103",
    title:"CuO as a reactive and reusable reagent for the hydrogenation of nitroarenes",
    authors:[
      "K. Rajendran",
      "N. Pandurangan",
      "C.P. Vinod",
      "Tuhin S. Khan",
      "Shelaka Gupta",
      "M. Ali Haider",
      "D. Jagadeesan*"
    ],
    other_details:"Applied Catalysis B (Environmental)., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1016/j.apcatb.2021.120417"
  },{
    id:"pub_104",
    title:"Role of Metal-Support Interaction for Atmospheric Pressure CO2 Hydrogenation over Pd/(Ti)-SBA-15 catalysts: Effects of Titanium Composition on Products Selectivity",
    authors:[
      "Yogita Soni*",
      "Sharad Gupta",
      "C. P. Vinod*"
    ],
    other_details:"Molecular Catalysis., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1016/j.mcat.2021.111732"
  },{
    id:"pub_105",
    title:"Unprecedented stability in Au@ Co core-shell bimetallic catalyst supported on SBA-15 (Au@ Co/SBA-15) for atmospheric pressure CO hydrogenation",
    authors:[
      "Preeti Jain",
      "Manali Chimote",
      "C P Vinod*"
    ],
    other_details:"Materials Today Sustainability., (2021)",
    year:"2021",
    doi:"https://doi.org/10.1016/j.mtsust.2021.100068"
  },{
    id:"pub_106",
    title:"Coordination flexibility aided CO2-specific gating in an Iron Isonicotinate MOF",
    authors:[
      "Ramanathan Vaidhyanathan*",
      "Himan Dev Singh",
      "Shyamapada Nandi",
      "Debanjan Chakraborty",
      "Kirandeep Singh",
      "C. P. Vinod"
    ],
    other_details:"Chemistry An Asian Journal., (2022)",
    year:"2022",
    doi:" https://doi.org/10.1002/asia.202101305"
    },{
    id:"pub_107",
    title:"Unravelling faradaic electrochemical efficiencies over Fe/Co spinel metal oxides using surface spectroscopy and microscopy techniques",
    authors:[
      "Varchaswal Kashyap",
      "Ajmal Pandikassala",
      "Gourav Singla",
      "Tuhin Suvra Khan",
      "M Ali Haider",
      "C.P. Vinod*",
      "Sreekumar Kurungot*"
    ],
    other_details:"Nanoscale., 14, 15928-15941 (2022)",
    year:"2022",
    doi:" https://doi.org/10.1039/D2NR04170G"
  },{
    id:"pub_108",
    title:"Synergistic Electronic Effects in AuCo Nanoparticles Stabilized in a Triazine-Based Covalent Organic Framework: A Catalyst for Methyl Orange and Methylene Blue Reduction",
    authors:[
      "Venkata Swaroopa Datta Devulapalli",
      "Rinku Kushwaha",
      "Edwin Ovalle",
      "Himan Dev Singh",
      "Pragalbh Shekhar",
      "Debanjan Chakraborty",
      "C P Vinod",
      "Ramanathan Vaidhyanathan*",
      "Eric Borguet*"
    ],
    other_details:"Appl. Nano Mater., (2022)",
    year:"2022",
    doi:"https://doi.org/10.1021/acsanm.1c04212"
  },{
    id:"pub_109",
    title:"Potential- and Time-Dependent Dynamic Nature of an Oxide-Derived PdIn Nanocatalyst during Electrochemical CO2 Reduction",
    authors:[
      "D Bagchi",
      "S Sarkar",
      "AK Singh",
      "C.P. Vinod",
      "SC Peter*"
    ],
    other_details:"ACS Nano., 16 (4), 6185 - 6196 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1021/acsnano.1c11664"
  },{
    id:"pub_110",
    title:"Controlled exchange bias behavior of manganese nanoparticles",
    authors:[
      "Garima Tiwari",
      "C P Vinod",
      "Balaji R Jagirdar*"
    ],
    other_details:"Journal of Magnetism and Magnetic Materials., 169504 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1016/j.jmmm.2022.169504"
  },{
    id:"pub_111",
    title:"Single-step insertion of M-Nx moieties in commercial carbon for sustainable bifunctional electrocatalysis: Mapping insertion capacity, mass loss, and carbon reconstruction",
    authors:[
      "Reeya Garg",
      "Lipipuspa Sahoo",
      "Komalpreet Kaur",
      "C.P. Vinod",
      "Ujjal K Gautam"
    ],
    other_details:"Carbon., 196, 1001 - 1011 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1016/j.carbon.2022.06.008"
  },{
    id:"pub_112",
    title:"Improvement in Oxygen Evolution Performance of NiFe Layered Double Hydroxide Grown in the Presence of 1T-Rich MoS2",
    authors:[
      "Soumita Chakraborty",
      "Shivanna Marappa",
      "Sakshi Agarwal",
      "Debabrata Bagchi",
      "Ankit Rao",
      "Chathakudath P Vinod",
      "Sebastian C Peter",
      "Abhishek Singh",
      "Muthusamy Eswaramoorthy"
    ],
    other_details:"ACS Applied Materials & Interfaces., (2022)",
    year:"2022",
    doi:"https://doi.org/10.1021/acsami.2c06210"
  },{
    id:"pub_113",
    title:"Incorporating Conducting Polypyrrole into a Polyimide COF for Carbon?Free Ultra?High Energy Supercapacitor",
    authors:[
      "Sattwick Haldar",
      "Deepak Rase",
      "Pragalbh Shekhar",
      "Chitvan Jain",
      "C. P. Vinod",
      "En Zhang",
      "Leonid Shupletsov",
      "Stefan Kaskel",
      "Ramanathan Vaidhyanathan"
    ],
    other_details:"Advanced Energy Materials., 12 (34), 2200754 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1002/aenm.202200754"
  },{
    id:"pub_114",
    title:"Regio-isomerism Directed Electrocatalysis for Energy Efficient Zinc-air Battery",
    authors:[
      "Sanchayita Mukhopadhyay",
      "Mruthyunjayachari Chattanahalli Devendrachari",
      "Sandeep C Kanade",
      "C. P. Vinod",
      "Harish Makri Nimbegondi Kotresh",
      "Musthafa Ottakam Thotiyl*"
    ],
    other_details:"iScience., (2022)",
    year:"2022",
    doi:"https://doi.org/10.1016/j.isci.2022.105179"
  },{
    id:"pub_115",
    title:"Single step strategy for crafting tin/carbon soot composite as highly stable Li?ion battery anode",
    authors:[
      "S Vashishth",
      "DK Singh",
      "C. P. Vinod",
      "E Muthusamy*"
    ],
    other_details:"Electrochemical Science Advances., (2022)",
    year:"2022",
    doi:"https://doi.org/10.1002/elsa.202100019"
  },{
    id:"pub_116",
    title:"Tuning of work function of ZnO by doping and co-doping: An investigation using X-ray photoelectron spectroscopy",
    authors:[
      "Soumya K",
      "I. Packia Selvam",
      "C P Vinod",
      "S. N. Potty*"
    ],
    other_details:"Thin Solid Films., (2022)",
    year:"2022",
    doi:"https://doi.org/10.1016/j.tsf.2022.139538"
  },{
    id:"pub_117",
    title:"Tuning the hybridization and charge polarization in metal nanoparticles dispersed over Schiff base functionalized SBA-15 enhances CO 2 capture and conversion to formic acid",
    authors:[
      "Arjun Cherevotan",
      "Bitan Ray",
      "Anish Yadav",
      "Debabrata Bagchi",
      "Ashutosh Kumar Singh",
      "Mohd Riyaz",
      "Sathyapal R Churipard",
      "Vinay Naral",
      "Komalpreet Kaur",
      "Ujjal K Gautam",
      "C. P. Vinod",
      "Sebastian C Peter*"
    ],
    other_details:"Journal of Materials Chemistry A., 10(35), 18354 - 18362 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1039/D2TA03690H"
  },{
    id:"pub_118",
    title:"A covalent organic framework with electrodeposited copper nanoparticles–a desirable catalyst for the Ullmann coupling reaction",
    authors:[
      "Chandana Chandran",
      "Himan Dev Singh",
      "Liya S Leo",
      "Pragalbh Shekhar",
      "Deepak Rase",
      "Debanjan Chakraborty",
      "C. P. Vinod",
      "Ramanathan Vaidhyanathan*"
    ],
    other_details:"Journal of Materials Chemistry A., 10(29), 15647 - 15656 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1039/D2TA01326F"
  },{
    id:"pub_119",
    title:"Influence of Support Textural Property on CO2 to Methane Activity of Ni/SiO2 Catalysts",
    authors:[
      "Arjun Cherevotan",
      "Bitan Ray",
      "Sathyapal R Churipard",
      "Komalpreet Kaur",
      "Ujjal K Gautam",
      "C P Vinod",
      "Sebastian C Peter*"
    ],
    other_details:"Applied Catalysis B: Environmental., 317, 121692 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1016/j.apcatb.2022.121692"
  },{
    id:"pub_120",
    title:"Noble-Metal-Free Heterojunction Photocatalyst for Selective CO2 Reduction to Methane upon Induced Strain Relaxation",
    authors:[
      "Risov Das",
      "Shreya Sarkar",
      "Ritesh Kumar",
      "Seethiraju D. Ramarao",
      "Arjun Cherevotan",
      "Mohammed Jasil",
      "C. P. Vinod",
      "Abhishek Kumar Singh",
      "Sebastian C. Peter*"
    ],
    other_details:"ACS Catalysis., , 687 - 697 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1021/acscatal.1c04587"
  },{
    id:"pub_121",
    title:"PdNi Alloy Nanowires as Highly Active ORR Electrocatalysts Exhibiting Morphology-Induced Durability over 200 K Cycles",
    authors:[
      "Lipipuspa Sahoo",
      "Reeya Garg",
      "Komalpreet Kaur",
      "C. P. Vinod",
      "Ujjal K. Gautam*"
    ],
    other_details:"Nano Letters., (2022)",
    year:"2022",
    doi:"https://doi.org/10.1021/acs.nanolett.1c03704"
  },{
    id:"pub_122",
    title:"Structure-Tailored Surface Oxide on Cu-Ga Intermetallics Enhances CO2 Reduction Selectivity to Methanol at Ultra-Low Potential",
    authors:[
      "Debabrata Bagchi",
      "Jithu Raj",
      "Ashutosh Kumar Singh",
      "Arjun Cherevotan",
      "Soumyabrata Roy",
      "Kaja Sai Manoj",
      "C.P. Vinod",
      "Sebastian C. Peter*"
    ],
    other_details:"Advanced Materials., 34 (19), 2109426 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1002/adma.202109426"
  },{
    id:"pub_123",
    title:"Morphology Tuned Pt3Ge Accelerates Water Dissociation to Industrial Standard Hydrogen Production over a wide pH Range",
    authors:[
      "Soumi Mondal",
      "Shreya Sarkar",
      "Debabrata Bagchi",
      "Tisita Das",
      "Risov Das",
      "Ashutosh Kumar Singh",
      "Ponnappa Kechanda Prasanna",
      "C.P. Vinod",
      "Sudip Chakraborty",
      "Sebastian C Peter*"
    ],
    other_details:"Advanced Materials., 34, 2202294 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1002/adma.202202294"
  },{
    id:"pub_124",
    title:"Strain-Enhanced Phase Transformation of Iron Oxide for Higher Alcohol Production from CO2",
    authors:[
      "D Goud",
      "SR Churipard",
      "D Bagchi",
      "AK Singh",
      "M Riyaz",
      "C.P. Vinod",
      "SC Peter*"
    ],
    other_details:"ACS Catalysis., 12 (18), 11118 - 11128 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1021/acscatal.2c03183"
  },{
    id:"pub_125",
    title:"Green Transformation of CO2 to Ethanol using Water and Sunlight by Cooperative Endeavour of Naturally Abundant Red Phosphorus and Bi2MoO6",
    authors:[
      "Risov Das",
      "Kousik Das",
      "Bitan Ray",
      "C P Vinod",
      "Sebastian C Peter*"
    ],
    other_details:"Energy and Environmental Science., (2022)",
    year:"2022",
    doi:"https://doi.org/10.1039/D1EE02976B"
  },{
    id:"pub_126",
    title:"In Situ Mechanistic Insights for the Oxygen Reduction Reaction in Chemically Modulated Ordered Intermetallic Catalyst Promoting Complete Electron Transfer",
    authors:[
      "S Mondal",
      "D Bagchi",
      "M Riyaz",
      "S Sarkar",
      "AK Singh",
      "C.P. Vinod",
      "SC Peter"
    ],
    other_details:"Journal of the American Chemical Society., 144, 26, 11859 - 11869 (2022)",
    year:"2022",
    doi:"https://doi.org/10.1021/jacs.2c04541"
  },{
    id:"pub_127",
    title:"Process for the preparation of bimetallic core/shell nanoparticles and their catalytic applications",
    authors:[
      "C P Vinod",
      "Vysakh Alengattil Bharathan"
    ],
    other_details:"US Patent 11,305,344 B2., (2022)",
    year:"2022"
  },{
    id:"pub_128",
    title:"La Cu based heterogeneous perovskite catalyst for highly selective benzene hydroxylation under mild conditions",
    authors:[
      "Pawan Kumar",
      "Anuradha Vijay Jagtap",
      "Sharad Gupta",
      "C. P. Vinod*"
    ],
    other_details:"Chem Asian J., (2022)",
    year:"2022",
    doi:"https://doi.org/10.1002/asia.202200788"
  },{
    id:"pub_129",
    title:"Structural ordering enhances highly selective production of acetic acid from CO 2 at ultra-low potential",
    authors:[
      "S Sarkar",
      "J Raj",
      "D Bagchi",
      "A Cherevotan",
      "C.P. Vinod",
      "SC Peter*"
    ],
    other_details:"EES Catalysis., 1 (2), 162 - 170 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1039/D2EY00081D"
  },{
    id:"pub_130",
    title:"Oxidation of ethylene by Cu/TiO 2: reducibility of Cu 2+ in TiO 2 as a possible descriptor of catalytic efficiency",
    authors:[
      "K Rajendran",
      "Mandeep Sharma",
      "Augustine Jaison",
      "Menon Ankitha",
      "Ankit D Tiwari",
      "C.P. Vinod",
      "Dinesh Jagadeesan*"
    ],
    other_details:"Catalysis Science & Technology., 13(8), 2330 - 2339 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1039/D2CY02170F"
  },{
    id:"pub_131",
    title:"Unprecedented energy storage in metal–organic complexes via constitutional isomerism",
    authors:[
      "Alagar Raja Kottaichamy",
      "Siraprapha Deebansok",
      "Jie Deng",
      "Mohammed Azeezulla Nazrulla",
      "Yachao Zhu",
      "Zahid Manzoor Bhat",
      "Mruthyunjayachari Chattanahalli Devendrachari",
      "Chathakudath Prabhakaran Vinod",
      "Harish Makri Nimbegondi Kotresh",
      "Olivier Fontaine",
      "Musthafa Ottakam Thotiyl*"
    ],
    other_details:"Chemical Science., 14 (23), 6383 - 6392 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1039/D3SC01692G"
  },{
    id:"pub_132",
    title:"Hydrogenation of levulinic acid to gamma-valerolactone over nickel supported organoclay catalyst",
    authors:[
      "PA Kamble",
      "C.P. Vinod",
      "VK Rathod",
      "ML Kantam*"
    ],
    other_details:"Catalysis Today., 408, 36 - 49 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1016/j.cattod.2022.10.004"
  },{
    id:"pub_133",
    title:"Enhancing the catalytic activity of Pd nanocrystals towards Suzuki Cross?Coupling by g?C3N4 photosensitization",
    authors:[
      "S Mondal",
      "L Sahoo",
      "M Banoo",
      "Y Vaishnav",
      "C.P. Vinod",
      "UK Gautam*"
    ],
    other_details:"ChemNanoMat., (2023)",
    year:"2023",
    doi:"https://doi.org/10.1002/cnma.202300451"
  },{
    id:"pub_134",
    title:"Intrinsic Charge Polarization in Bi19S27Cl3 Nanorods Promotes Selective C?C Coupling Reaction during Photoreduction of CO2 to Ethanol",
    authors:[
      "Kousik Das",
      "Risov Das",
      "Mohd Riyaz",
      "Arko Parui",
      "Debabrata Bagchi",
      "Ashutosh Kumar Singh",
      "Abhishek Kumar Singh",
      "Chathakudath P Vinod",
      "Sebastian C Peter*"
    ],
    other_details:"Advanced Materials., 35 (5), 2205994 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1002/adma.202205994"
  },{
    id:"pub_135",
    title:"Wurtzite CuGaS2 with an In?Situ?Formed CuO Layer Photocatalyzes CO2 Conversion to Ethylene with High Selectivity",
    authors:[
      "Subhajit Chakraborty",
      "Risov Das",
      "Mohd Riyaz",
      "Kousik Das",
      "Ashutosh Kumar Singh",
      "Debabrata Bagchi",
      "Chathakudath P Vinod",
      "Sebastian C Peter*"
    ],
    other_details:"Angewandte Chemie., 135 (9), (2023)",
    year:"2023",
    doi:"https://doi.org/10.1002/anie.202216613"
  },{
    id:"pub_136",
    title:"Covalently interconnected layers in g-C3N4: Toward high mechanical stability, catalytic efficiency and sustainability",
    authors:[
      "Raj Sekhar Roy",
      "Sanjit Mondal",
      "Samita Mishra",
      "Maqsuma Banoo",
      "Lipipuspa Sahoo",
      "Amit Kumar",
      "C.P. Vinod",
      "Arijit K De",
      "Ujjal K Gautam*"
    ],
    other_details:"Applied Catalysis B: Environmental., 322, 122069 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1016/j.apcatb.2022.122069"
  },{
    id:"pub_137",
    title:"Imine Oxidation Catalyzed by Zinc Hydroxyapatite: Kinetic Studies",
    authors:[
      "Rakhi Vishwakarma",
      "C.P. Vinod",
      "Virendra K Rathod",
      "Mannepalli Lakshmi Kantam*"
    ],
    other_details:"ChemistrySelect., (2023)",
    year:"2023",
    doi:"https://doi.org/10.1002/slct.202203503"
  },{
    id:"pub_138",
    title:"Wadsworth–Emmons Reaction by Using the Fluorapatite Catalyst: Kinetic Studies",
    authors:[
      "Rakhi Vishwakarma",
      "Chathakudath P Vinod",
      "Virendra Rathod",
      "Mannepalli Lakshmi Kantam*"
    ],
    other_details:"Industrial & Engineering Chemistry Research., 62, 20, 7901 - 7911 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1021/acs.iecr.3c00407"
  },{
    id:"pub_139",
    title:"Unusual Ligand Assistance in Molecular Electrocatalysis via Interfacial Proton Charge Assembly",
    authors:[
      "Sanchayita Mukhopadhyay",
      "Alagar Raja Kottaichamy",
      "Pallavi Vyankuram Chame",
      "Prasenjit Ghosh",
      "Chathakudath Prabhakaran Vinod",
      "Harish Makri Nimbegondi Kotresh",
      "Sandeep C Kanade",
      "Musthafa Ottakam Thotiyl*"
    ],
    other_details:"The Journal of Physical Chemistry Letters., 14, 5377 - 5385 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1021/acs.jpclett.3c01262"
  },{
    id:"pub_140",
    title:"Copper Fluorapatite-Catalyzed Aza-Michael Reaction and Kinetic Studies",
    authors:[
      "R Vishwakarma",
      "C.P. Vinod",
      "V Rathod",
      "ML Kantam*"
    ],
    other_details:"Industrial & Engineering Chemistry Research., 62 (34), 13401 - 13411 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1021/acs.iecr.3c01383"
  },{
    id:"pub_141",
    title:"Metal Deficiency Tailored by the 18-Electron Rule Stabilizes Metal-Based Inorganic Compounds",
    authors:[
      "AK Singh",
      "D Mumbaraddi",
      "V Mishra",
      "S Roy",
      "C.P. Vinod",
      "SC Peter*"
    ],
    other_details:"Chemistry of Materials., 35 (15), 6050 - 6058 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1021/acs.chemmater.3c01142"
  },{
    id:"pub_142",
    title:"Active Site Engineering and Theoretical Aspects of “Superhydrophilic” Nanostructure Array Enabling Efficient Overall Water Electrolysis",
    authors:[
      "Sidharth Barik",
      "Geeta Pandurang Kharabe",
      "Rajith Illathvalappil",
      "Chandrodai Pratap Singh",
      "Fayis Kanheerampockil",
      "Priyanka S Walko",
      "Suresh K Bhat",
      "R Nandini Devi",
      "C.P. Vinod*",
      "Sailaja Krishnamurty*",
      "Sreekumar Kurungot*"
    ],
    other_details:"Small., (2023)",
    year:"2023",
    doi:"https://doi.org/10.1002/smll.202304143"
  },{
    id:"pub_143",
    title:"Made to Measure Squaramide COF Cathode for Zinc Dual?Ion Battery with Enriched Storage via Redox Electrolyte",
    authors:[
      "Rinku Kushwaha",
      "Chitvan Jain",
      "Pragalbh Shekhar",
      "Deepak Rase",
      "Rajith Illathvalappil",
      "Deep Mekan",
      "Augastus Camellus",
      "Chathakudath Prabhakaran Vinod",
      "Ramanathan Vaidhyanathan*"
    ],
    other_details:"Advanced Energy Materials., 13 (34), 2301049 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1002/aenm.202301049"
  },{
    id:"pub_144",
    title:"Distortion-Induced Interfacial Charge Transfer at Single Cobalt Atom Secured on Ordered Intermetallic Surface Enhances Pure Oxygen Production",
    authors:[
      "Soumi Mondal",
      "Mohd Riyaz",
      "Debabrata Bagchi",
      "Nilutpal Dutta",
      "Ashutosh Kumar Singh",
      "Chathakudath P Vinod",
      "Sebastian C Peter*"
    ],
    other_details:"ACS Nano., 7, 22, 23169 - 23180 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1021/acsnano.3c09680"
  },{
    id:"pub_145",
    title:"Tailoring COFs: Transforming Nonconducting 2D Layered COF into a Conducting Quasi-3D Architecture via Interlayer Knitting with Polypyrrole",
    authors:[
      "Chitvan Jain",
      "Rinku Kushwaha",
      "Deepak Rase",
      "Pragalbh Shekhar",
      "Ankita Shelke",
      "Disha Sonwani",
      "Thalasseril G Ajithkumar",
      "Chathakudath Prabhakaran Vinod",
      "Ramanathan Vaidhyanathan*"
    ],
    other_details:"Journal of the American Chemical Society., (2023)",
    year:"2023",
    doi:"https://doi.org/10.1021/jacs.3c09937"
  },{
    id:"pub_146",
    title:"Pd Nanoparticles Supported on N-Incorporated Hybrid Organosilica as an Active and Selective Low-Temperature Phenol Hydrogenation Catalyst",
    authors:[
      "KJ Betsy",
      "P Bajpai",
      "A Lazar",
      "K Vanka",
      " C.P. Vinod*"
    ],
    other_details:"ACS Applied Nano Materials., 6, 13, 11500 - 11512 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1021/acsanm.3c01540"
  },{
    id:"pub_147",
    title:"Morphology-Dependent Catalysis by Co3O4 Nanostructures in Atmospheric Pressure Carbon Dioxide Hydrogenation",
    authors:[
      "S Gupta",
      "P Jain",
      "D Jagadeesan",
      "C. P. Vinod*"
    ],
    other_details:"The Journal of Physical Chemistry C., 127 (27), 13055 - 13064 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1021/acs.jpcc.3c02857"
  },{
    id:"pub_148",
    title:"Deciphering Particle Morphology Effects in Cinnamaldehyde Hydrogenation over Palladium Nanostructures",
    authors:[
      "G Porwal",
      "H KV",
      "S Sreedhala",
      "TS Khan",
      "MA Haider*",
      "C.P. Vinod*"
    ],
    other_details:"ACS Engineering Au., 3, 6, 477 - 487 (2023)",
    year:"2023",
    doi:"https://doi.org/10.1021/acsengineeringau.3c00017"
  },{
    id:"pub_149",
    title:"Electrochemical energy storage in an organic supercapacitor via a non-electrochemical proton charge assembly",
    authors:[
      "Sanchayita Mukhopadhyay",
      "Alagar Raja Kottaichamy",
      "Mruthyunjayachari Chattanahalli Devendrachari",
      "Rahul Mahadeo Mendhe",
      "Harish Makri Nimbegondi Kotresh",
      "Chathakudath Prabhakaran Vinod",
      "Musthafa Ottakam Thotiyl*"
    ],
    other_details:"Chemical Science., 15, 1726 - 1735 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1039/D3SC05639B"
  },{
    id:"pub_150",
    title:"Iron-catalyzed (E)-selective hydrosilylation of alkynes: scope and mechanistic insights",
    authors:[
      "A Sen",
      "T Tewari",
      "R Kumar",
      "C.P. Vinod",
      "H Sharma",
      "K Vanka",
      "SH Chikkali*"
    ],
    other_details:"Catalysis Science & Technology., 14 (10), 2752 - 2760 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1039/D3CY01775C"
  },{
    id:"pub_151",
    title:"Facile synthesis of nanostructured Ni/NiO/N-doped graphene electrocatalysts for enhanced oxygen evolution reaction",
    authors:[
      "R Madampadi",
      "AB Patel",
      "C.P. Vinod",
      "R Gupta",
      "D Jagadeesan*"
    ],
    other_details:"Nanoscale Advances., 6 (11), 2813 - 2822 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1039/D4NA00141A"
  },{
    id:"pub_152",
    title:"Fuel from waste: electrosynthesizing ammonia directly from agricultural digestate through ligand isomerization",
    authors:[
      "Rahul Mahadeo Mendhe",
      "Ritwik Mondal",
      "Alagar Raja Kottaichamy",
      "Akshay Haridas",
      "Harish Makri Nimbegondi Kotresh",
      "Chathakudath Prabhakaran Vinod",
      "Ravikumar Thimmappa",
      "Musthafa Ottakam Thotiyl*"
    ],
    other_details:"Green Chemistry., 26, 6490 - 6500 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1039/D4GC00740A"
  },{
    id:"pub_153",
    title:"Kinetic Model of Hydrogenation of Glucose to Sorbitol on a Ni/Bentonite Catalyst",
    authors:[
      "H Pandya",
      "C.P. Vinod",
      "V Rathod",
      "ML Kantam"
    ],
    other_details:"Industrial & Engineering Chemistry Research., 63 (11), 4771 - 4781 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1021/acs.iecr.3c03808"
  },{
    id:"pub_154",
    title:"Hydrogenation of furfural to tetrahydrofurfuryl alcohol over nickel-supported on organoclay catalyst",
    authors:[
      "PA Kamble",
      "C.P. Vinod",
      "VK Rathod",
      "ML Kantam*"
    ],
    other_details:"Applied Catalysis A: General., 674, 119621 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1016/j.apcata.2024.119621"
  },{
    id:"pub_155",
    title:"Unraveling the Cooperative Mechanisms in Ultralow Copper-Loaded WC@NGC for Enhanced CO2 Electroreduction to Acetic Acid",
    authors:[
      "Debabrata Bagchi",
      "Mohd Riyaz",
      "Jithu Raj",
      "Soumyabrata Roy",
      "Ashutosh Kumar Singh",
      "Arjun Cherevotan",
      "Chathakudath P Vinod",
      "Sebastian C Peter*"
    ],
    other_details:"Chemistry of Materials., 36 (7), 3464 - 3476 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1021/acs.chemmater.4c00405"
  },{
    id:"pub_156",
    title:"Photocatalytic Regeneration of Reactive Cofactors with InP Quantum Dots for the Continuous Chemical Synthesis",
    authors:[
      "IN Chakraborty",
      "V Jain",
      "P Roy",
      "P Kumar",
      "C.P. Vinod",
      "PP Pillai*"
    ],
    other_details:"ACS Catalysis., 14 (9), 6740 - 6748 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1021/acscatal.4c00817"
  },{
    id:"pub_157",
    title:"Aluminium, Nitrogen-Dual-Doped Reduced Graphene Oxide Co-Existing with Cobalt-Encapsulated Graphitic Carbon Nanotube as an Activity Modulated Electrocatalyst for Oxygen Electrocatalyst for Oxygen Electrochemistry Applications",
    authors:[
      "Geeta Pandurang Kharabe",
      "Sidharth Barik",
      "Sudheesh Kumar Veeranmaril",
      "Aathira Nair",
      "Rajith Illathvalappil",
      "Athira Yoyakki",
      "Kavita Joshi*",
      "Chathakudath Prabhakaran Vinod*",
      "Sreekumar Kurungot*"
    ],
    other_details:"Small., (2024)",
    year:"2024",
    doi:"https://doi.org/10.1002/smll.202400012"
  },{
    id:"pub_158",
    title:"Ligand Isomerization Driven Electrocatalytic Switching",
    authors:[
      "Alagar Raja Kottaichamy",
      "Mohammed Azeezulla Nazrulla",
      "Muskan Parmar",
      "Ravikumar Thimmappa",
      "Mruthyunjayachari Chattanahalli Devendrachari",
      "Chathakudath Prabhakaran Vinod",
      "Michael Volokh",
      "Harish Makri Nimbegondi Kotresh",
      "Menny Shalom",
      "Musthafa Ottakam Thotiyl*"
    ],
    other_details:"Angewandte Chemie., (2024)",
    year:"2024",
    doi:"https://doi.org/10.1002/anie.202405664"
  },{
    id:"pub_159",
    title:"Hydrogenation of Glucose to Sorbitol by Using Nickel Hydroxyapatite Catalyst",
    authors:[
      "PA Kamble",
      "C.P. Vinod",
      "VK Rathod",
      "M Lakshmi Kantam*"
    ],
    other_details:"ChemCatChem., 16 (9), e202301590 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1002/cctc.202301590"
  },{
    id:"pub_160",
    title:"Resorcinol–Azodianiline Covalent Organic Framework Supported FeOOH Quantum Dot-Catalyzed Electrochemical Ammonia Synthesis under Ambient Conditions",
    authors:[
      "Pragalbh Shekhar",
      "Kento Kosugi",
      "Himan Dev Singh",
      "Rinku Kushwaha",
      "Deepak Rase",
      "Takumi Matsuzaki",
      "Chitvan Jain",
      "Piyush Singh",
      "Yashraj Singh",
      "C P Vinod",
      "Mio Kondo*",
      "Shigeyuki Masaoka*",
      "Ramanathan Vaidhyanathan*"
    ],
    other_details:"Chemistry of Materials., (2024)",
    year:"2024",
    doi:"https://doi.org/10.1021/acs.chemmater.4c00859"
  },{
    id:"pub_161",
    title:"Atmospheric-Pressure Continuous-Flow Methane Oxidation to Methanol and Acetic Acid Using H2O2 over the Au–Fe Catalyst",
    authors:[
      "Anuradha V Jagtap",
      "Pawan Kumar",
      "Sharad Gupta",
      "Abharana Nagendra",
      "Shambhu Nath Jha",
      "Dibyendu Bhattacharyya",
      "Thalasseril G Ajithkumar",
      "C.P. Vinod*"
    ],
    other_details:"ACS Sustainable Chemistry & Engineering., 12, 23, 8958 - 8967 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1021/acssuschemeng.4c02993"
  },{
    id:"pub_162",
    title:"Exploring the CeO2 Support Morphology for the Carbon Dioxide Hydrogenation Reaction using Nickel Catalysts",
    authors:[
      "S  Gupta",
      "A Jagtap",
      "C.P. Vinod*"
    ],
    other_details:"The Journal of Physical Chemistry C., 128, 44, 18782–18792 (2024)",
    year:"2024",
    doi:"https://doi.org/10.1021/acs.jpcc.4c05258"
  },{
    id:"pub_163",
    title:"Breaking the Pt Electron Symmetry and OH Spillover towards PtIr Active Center for Performance Modulation in Direct Ammonia Fuel Cell",
    authors:[
      "Sidharth Barik",
      "Geeta Pandurang Kharabe",
      "Pragnya Paramita Samal",
      "Rajashri R Urkude",
      "Sachin Kumar",
      "Athira Yoyakki",
      "C.P. Vinod*",
      "Sailaja Krishnamurty*",
      "Sreekumar Kurungot*"
    ],
    other_details:"Small., 20, 49, (2024)",
    year:"2024",
    doi:"https://doi.org/10.1002/smll.202406589"
  },{
    id:"pub_164",
    title:"Enhanced light–matter interaction in gas nitridation-derived TiNx thin films for potential plasmonic applications",
    authors:[
      "L Tony",
      "IP Selvam",
      "C.P. Vinod",
      "SN Potty"
    ],
    other_details:"Journal of Materials Science, 1-17 (2024)",
    year:"2024"
  },{
    id:"pub_165",
    title:"Ultra-Small Pd Nanoparticles on SBA-15: An Efficient Catalyst for One-Pot Reductive Alkylation of Nitrobenzene with Size-Dependent Activity",
    authors:[
      "Y Soni*",
      "MC Philip",
      "C.P. Vinod*"
    ],
    other_details:"Topics in Catalysis., 1-16 (2024)",
    year:"2024",
    doi:"https://dx.doi.org/10.1007/s11244-024-02042-3"
  },{
    id:"pub_166",
    title:"Metal deficiency tuned charge transfer in intermetallic Ni 2− x Sn (x= 0.37–0.65) enhances selective conversion of furfural to furfuryl alcohol towards the theoretical limit",
    authors:[
      "Arjun Cherevotan",
      "Ashutosh Kumar Singh",
      "Anish Yadav",
      "Raghu V Maligal-Ganesh",
      "Jithu Raj",
      "Anu Pulparambil",
      "Devender Goud",
      "Chathakudath P Vinod",
      "Sebastian C Peter*"
    ],
    other_details:"Journal of Materials Chemistry A., 13, 6042-6048 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1039/D4TA06383J"
  },{
    id:"pub_167",
    title:"Synthesis of glycolic acid from glyoxal by using hydrotalcite catalyst and kinetic studies",
    authors:[
      "Harmitkumar N Pandya",
      "Paresh A Kamble",
      "Chathakudath P Vinod",
      "Virendra Rathod",
      "Mannepalli Lakshmi Kantam*"
    ],
    other_details:"ChemCatChem, 17,12, e202500321 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1002/cctc.202500321"
  },{
    id:"pub_168",
    title:"W/HAP catalyzed terpenic alcohols oxidation: kinetic studies",
    authors:[
      "Aishwarya Poman",
      "Paresh A Kamble",
      "Chathakudath P Vinod",
      "Virendra Rathod",
      "Mannepalli Lakshmi Kantam*"
    ],
    other_details:"Reaction Chemistry & Engineering, 10, 2696-2710 (2025)",
    year:"2025",
    doi:"DOI	https://doi.org/10.1039/D5RE00132C"
  },{
    id:"pub_169",
    title:"Synthesis of 5-hydroxymethylfurfural from glucose using a tert-butoxyapatite catalyst",
    authors:[
      "Hemant S Kulkarni",
      "Paresh A Kamble",
      "Chathakudath P Vinod",
      "Virendra Rathod",
      "Mannepalli Lakshmi Kantam*"
    ],
    other_details:"Dalton Transactions, 54, 13574-13587 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1039/D5DT01450F"
  },{
    
    id:"pub_170",
    title:"Hot Injection Assisted Electronically Modulated Twin and Grain Boundary Rich Sub‐2 nm Pt3Co Alloy Resistant to Phosphate Ion for PEMFCs",
    authors:[
      "Mayank U Singh",
      "Swapnil D Jadhav",
      "Bhavana R Shivankar",
      "Ajmal Pandikassala",
      "Yogesh Kumar",
      "Sailaja Krishnamurty*",
      "C.P. Vinod*",
      "Sreekumar Kurungot*"
    ],
    other_details:"Small, 21 (20), 2500954 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1002/smll.202500954"
  },{
    id:"pub_171",
    title:"Dopant and Exfoliation Induced Simultaneous Modification of Charge Density and C─C Coupling Sites for Efficient CO2 Photoreduction to Ethylene",
    authors:[
      "Kousik Das",
      "Subhajit Chakraborty",
      "Siddhi Kediya",
      "Ashutosh Kumar Singh",
      "Risov Das",
      "Soumi Mondal",
      "Mohd Riyaz",
      "Devender Goud",
      "Nilutpal Dutta",
      "Chathakudath P Vinod",
      "Sebastian C Peter*"
    ],
    other_details:"Angew Chem, 64, 28, e202423471 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1002/anie.202423471"
  },{
    id:"pub_172",
    title:"Hydrogenation of CO2 Catalyzed by Thermally Decomposed Cobalt-Containing Alkaline Earth Metal Carbonates",
    authors:[
      "Sharad Gupta*",
      "C.P. Vinod",
      "Christophe Poupin",
      "Dinesh Jagadeesan*"
    ],
    other_details:"Energy and Fuels, 39, 27, 12982–12991 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1021/acs.energyfuels.5c01793"
  },{
    id:"pub_173",
    title:"Selective Hydrogenation of Furfural to Furfuryl Alcohol over Pd Supported on Ternary Oxide in Aqueous Medium Under Mild Conditions",
    authors:[
      "Pooja Nehra",
      "K J Betsy",
      "C P Vinod*"
    ],
    other_details:"Chem Cat Chem, 17, 15, e02092 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1002/cctc.202402092"
    },{
    id:"pub_174",
    title:"A Tunable, Amine‐Functionalized Porous Silica Catalyst for CO2 Transformation into Cyclic Organic Carbonates at Atmospheric Pressure",
    authors:[
      "Twinkle Gorai",
      "Chandragopal Thanasekar",
      "Pawan Kumar",
      "Athira Babu",
      "Sreekumar Kurungot",
      "C P Vinod*"
    ],
    other_details:"Chemistry–A European Journal, 31, 47, e00873 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1002/chem.202500873"
  },{
    id:"pub_175",
    title:"Towards improved activity and stability in RWGS reaction: Dispersed copper in mesoporous alumina matrix as a strategy for enhanced performance",
    authors:[
      "Simi Saju",
      "Sivaraj Rajendran",
      "Ulviye Oztas",
      "Sergio Carrasco Ruiz",
      "Tomas Ramirez Reina",
      "Biplab Ghosh",
      "Sreeprasanth Pulinthanathu Sree",
      "Raghavendra Meena",
      "Guanna Li",
      "Luis F Bobadilla",
      "C.P. Vinod",
      "Thomas Mathew*",
      "N Raveendran Shiju*"
    ],
    other_details:"Chemical Engineering Journal, 525, 15, 169863 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1016/j.cej.2025.169863"
  },{
    id:"pub_176",
    title:"Facet dependence for solvent-modulated proton coupled electron transfer in furfural acetalization on Pd nanostructures",
    authors:[
      "G Porwal",
      "P Dandekar",
      "T Gorai",
      "TS Khan",
      "MA Haider*",
      "S Gupta*",
      "C.P. Vinod*"
    ],
    other_details:"Chemical Engineering Journal, 514, 15, 163159 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1016/j.cej.2025.163159"
  },{
    id:"pub_177",
    title:"Unravelling the Cu-Co nanoparticle synergy over Ceria-Zirconia support toward efficient reverse water gas shift (RWGS) conversion under H2 lean conditions",
    authors:[
      "Anuradha Vijay Jagtap",
      "Mahesh Kumar Bamnia",
      "Ashakiran Maibam",
      "Jyotsna Paliwal Bajpai",
      "Sharad Gupta",
      "Sharon K Thomas",
      "Niteen B Dabke",
      "C.P. Vinod*"
    ],
    other_details:"Chemical Engineering Journal, 508, 15, 160705 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1016/j.cej.2025.160705"
  },{
 id:"pub_178",
    title:"Exploring the electronic modulation in controlling the activity and selectivity of Ni-Au-In based catalyst in atmospheric pressure CO2 hydrogenation",
    authors:[
      "Jyotsna P Bajpai",
      "Sharad Gupta",
      "Devender Goud",
      "JDiku Raj Deka",
      "Anuradha V Jagtap",
      "Pawan Kumar",
      "Momin Ahamed",
      "Sebastian C Peter",
      "C.P. Vinod*"
    ],
    other_details:"Chemical Engineering Journal, 520, 15, 165921 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1016/j.cej.2025.165921"
    },{
 id:"pub_179",
    title:"A Pt-Based Carbon-Free Cathode with Embedded Oxygen Nanoreservoirs: A Promising Approach for Oxygen Buffering to Aid Oxygen Reduction Reactions of PEMFCs",
    authors:[
      "Athira Yoyakki",
      "Sachin Kumar",
      "Ajmal Pandikassala",
      "Swapnil D Jadhav",
      "C.P. Vinod*",
      "Sreekumar Kurungot*"
    ],
    other_details:"ACS Catalysis, 15, 19677-19694 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1021/acscatal.5c06455"
     },{
 id:"pub_180",
    title:"Aldol Condensation of Furfural with Acetone by Using Mg–Al–O-t-Bu HT Catalyst and Kinetic Studies",
    authors:[
      "S Patil",
      "P Kamble",
      "C P Vinod",
      "V Rathod",
      "ML Kantam*",
    ],
    other_details:"Industrial & Engineering Chemistry Research, 64,52, 24938–24948 (2025)",
    year:"2025",
    doi:"https://doi.org/10.1021/acs.iecr.5c03287"
    },{
 id:"pub_181",
    title:"Direct conversion of methane to formic acid over Au–Fe-NaZSM-5 at ambient pressure using H 2 O 2",
    authors:[
      "Pawan Kumar",
      "Iqra Ahangar",
      "Srishti Kesarwani",
      "Rajashri Urkude",
      "Nita AR Patil",
      "Prashant Niphadkar",
      "Vijay V Bokade",
      "M Ali Haider",
      " C P Vinod*",
    ],
    other_details:"Catalysis Science & Technology, (2026)",
    year:"2026",
    doi:"https://doi.org/10.1039/D5CY01422K"
  } ,{
 id:"pub_182",
    title:"Atomic-Level Engineering in Lattice Strain-Driven Pt3Ir-Skin@Pt6IrCo with Mesoscale Mass Transport Regulation for Ammonia Oxidation Reaction in Direct Ammonia Fuel Cells",
    authors:[
      "Sidharth Barik",
      "Pragnya Paramita Samal",
      "Geeta Pandurang Kharabe",
      "Rajashri Urkude",
      "Swapnil Jadhav",
      "Yogesh Kumar",
      "Biplab Ghosh",
      "Kirti Dahiya",
      "C P Vinod*",
      "Sailaja Krishnamurty*",
      "Sreekumar Kurungot*",
    ],
    other_details:"ACS Catalysis, 6, 10, 9180–9198 (2026)",
    year:"2026",
    doi:"https://doi.org/10.1021/acscatal.6c00594"  
  },{
 id:"pub_183",
    title:"Synthesis of Raspberry Ketone Using Aluminium Bentonite Catalyst",
    authors:[
      "Rutuja S Patange",
      "Paresh A Kamble",
      "C P Vinod",
      "Virendra K Rathod,",
      "Mannepalli Lakshmi Kantam*",
    ],
    other_details:"Flavour and Fragrance Journal,41 (5), 1310-1318 (2026)",
    year:"2026",
    doi:"https://doi.org/10.1002/ffj.70120"
   },{
 id:"pub_184",
    title:"Development of a Kinetic Model for the Hydrogenolysis of Glycerol to Propylene Glycol by Using Ni/FAP Catalyst",
    authors:[
      "Harmitkumar N Pandya",
      "Paresh A Kamble",
      "C P Vinod",
      "Virendra K Rathod,",
      "Mannepalli Lakshmi Kantam*",
    ],
    other_details:"ChemCatChem,18 (14), e70929",
    year:"2026",
    doi:"https://doi.org/10.1002/cctc.70929"
   },{
 id:"pub_185",
    title:"Stabilization of Ligand-Free Small Gold Nanocluster Within a Metal–Organic Framework for Enhanced Hydrogen Evolution and Horseradish Peroxidase-Mimicking Catalysis in Aqueous Media",
    authors:[
      "Glory James",
      "Ravari Kandy Aparna",
      "Dhananjay",
      "Arun Karmakar",
      "Vikas Tiwari",
      "Udupa Sujit Manjunatha",
      "Sona Shaju Rose",
      "Alok Kumar",
      "Nonappa",
      "Seiji Yamazoe",
      "Soichi Kikkawa",
      "C P Vinod ",
      "Ravishankar Narayanan ",
      "Subrata Kundu ",
      "Tarak Karmakar ",
      "Sukhendu Mandal*",
    ],
    other_details:"Small,22 (46), e74276",
    year:"2026",
    doi:"https://doi.org/10.1002/smll.74276"
   },{
 id:"pub_186",
    title:"Unraveling the Mechanism of Higher Alcohol Production on the Ordered PdCu3 Nanointermetallic Surface during CO2 Electroreduction",
    authors:[
      "Debabrata Bagchi",
      "Jayendran Iyer",
      "Tuhin S Khan",
      "Geetansh Chawla",
      "Nilutpal Dutta",
      "Bishnubasu Giri",
      "Ashutosh Kumar Singh",
      "Saurav Saha",
      "Komalpreet Kaur",
      "CP Vinod",
      "Ujjal K Gautam",
      "M Ali Haider",
      "Sebastian C Peter*",
    ],
    other_details:"ACS Catalysis, 16, 13, 12486–12504 (2026)",
    year:"2026",
    doi:"https://doi.org/10.1021/acscatal.6c02384"
   },{  
id:"pub_187",
    title:"Selectivity Reversal from CO to Ethylene Products in CO2 Photoreduction via Electronic Modulation of SnS2 Using a Vinyl-Bridged Porous Organic Polymer",
    authors:[
      "Subhajit Chakraborty",
      "Bishal Boro",
      "SA Keishana Navodye",
      "Rajib Ghosh",
      "Abhijit Shrotri",
      "Rajashri Urkude",
      "Geetansh Chawla",
      "CP Vinod",
      "GT Kasun Kalhara Gunasooriya",
      "John Mondal",
      "Sebastian C Peter*",
    ],
    other_details:"Journal of the American Chemical Society, 148, 25, 25669–25684 (2026)",
    year:"2026",
    doi:"https://doi.org/10.1021/jacs.6c02822"
   },{
id:"pub_188",
    title:"Poly(styrenesulfonate):Poly(3,4-ethylenedioxythiophene) (PSS:PEDOT) Based Mixed Electronic and Ionic Conducting COF",
    authors:[
      "Chitvan Jain",
      "Rinku Kushwaha",
      "Sudipta Majumder",
      "Yashraj Singh",
      "Piyush Singh",
      "Augastus Camellus",
      "CP Vinod",
      "Atikur Rahman",
      "Ramanathan Vaidhyanathan*",
    ],
    other_details:"Small, e74693",
    year:"2026",
    doi:"https://doi.org/10.1002/smll.74693"
   },{
id:"pub_189",
    title:"Ambient-pressure continuous-flow methane oxidation to methanol: Harnessing in-situ H2O2 generation for sustainable catalysis",
    authors:[
      "Pawan Kumar",
      "Anuradha V Jagtap",
      "Nikhil S Samudre",
      "Tanmay Ghosh",
      "Rajashri Urkude",
      "Sailaja Krishnamurty",
      " C P Vinod*",
    ],
    other_details:"Applied Surface Science,749, 167911 (2026)",
    year:"2026",
    doi:"10.1016/j.apsusc.2026.167911"
  },{
id:"pub_190",
    title:"Interlocked Regulation of Surface Poisoning and Ion Diffusion Enabled by Tungsten Integration and Holey Graphene Oxide Support for Ammonia Oxidation",
    authors:[
      "Kirti Dahiya",
      "Sidharth Barik",
      "Nikhil S Samudre",
      "Swapnil Jadhav",
      "Sailaja Krishnamurty*",
      "C P Vinod*",
      "Sreekumar Kurungot*",
    ],
    other_details:"Chemistry of Materials,38 (19), 10118–10134 (2026)",
    year:"2026",
    doi:"10.1021/acs.chemmater.6c01697"            
  },
  
];